import { render, staticRenderFns } from "./SalePricesUnitForm.vue?vue&type=template&id=323b6716&scoped=true"
import script from "./SalePricesUnitForm.vue?vue&type=script&lang=js"
export * from "./SalePricesUnitForm.vue?vue&type=script&lang=js"
import style0 from "./SalePricesUnitForm.vue?vue&type=style&index=0&id=323b6716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323b6716",
  null
  
)

export default component.exports